// Raw material requisition
export const materialRequisitionListApi = 'store-management/raw-material-requisition/list'
export const materialRequisitionApproveListApi = 'store-management/raw-material-requisition/approve-list'
export const materialRequisitionStoreApi = 'store-management/raw-material-requisition/store'
export const materialForwardUpdateApi = 'store-management/raw-material-requisition/forward-update'
export const materialRequisitionUpdateApi = 'store-management/raw-material-requisition/update'
export const rawMaterialInfoById = 'store-management/raw-material-requisition/raw-material-info-data'
export const userListByDesignationApi = 'user/users-by-designation-id'

// Raw material requisition request
export const rawMatRequisitionReqListApi = 'store-management/raw-material-requisition-request/list'
export const rawMatReqApproveQtyApi = 'store-management/raw-material-requisition-request/update'
export const rawMatForwardToForwardApi = 'store-management/raw-material-requisition-request/forward-to-forward-update'
export const rawMatApproveDenyApi = 'store-management/raw-material-requisition-request/approve-deny'

// Raw material disburse api
export const rawMatDisburseListApi = 'store-management/raw-material-disburse/list'
export const rawMatDisburseStoreApi = 'store-management/raw-material-disburse/store'
export const centralAvailableStockApi = 'store-management/raw-material-disburse/available-stock'
// Raw material disbursement api
export const rawMatDisbursementListApi = 'store-management/raw-material-disbursement/list'

// Production-target-api
export const productionTargetListApi = 'store-management/production-target-manage/list'
export const productionTargetStoreApi = 'store-management/production-target-manage/store'
export const productionTargetUpdateApi = 'store-management/production-target-manage/update'
export const productionForwardUpdateApi = 'store-management/production-target-manage/forward-update'
export const productionTargetToggleStatusApi = 'store-management/production-target-manage/toggle-status'
export const productionTargetById = 'store-management/production-target-manage/production-target-data'
export const userListApi = 'user/get-all-users'
// Production-target-request-api
export const productionRequestListApi = 'store-management/production-target-request/list'
export const productionRequestForwardUpdateApi = 'store-management/production-target-request/forward-update'
export const productionTargetRequestUpdateApi = 'store-management/production-target-request/update'
export const productionTargetRequestStatusUpdateApi = 'store-management/production-target-request/update-status'
// Production-target-approve-list-api
export const productionRequestApproveListApi = 'store-management/production-target-approve-list/list'
// production-stock-manage-api
export const productionStockList = 'store-management/production-stock-manage/list'
export const productionStockStore = 'store-management/production-stock-manage/store'
export const productionStockUpdate = 'store-management/production-stock-manage/update'
export const productionStockToggleStatus = 'store-management/production-stock-manage/toggle-status'
export const productionAvailableStock = 'store-management/production-stock-manage/get-available-stock'
// Product-stock-report-api
export const productStockReportList = 'store-management/stock-report/list'
// monthly-stock-report-api
export const fiscalYearData = 'master-fiscal-year/show'
export const targetVsProductionReportList = 'store-management/target-production-stock-report/list'
// mukta-water-monthly-stock-report-api
export const waterProductionSalesAndStockReportApi = 'store-management/water-production-sales-stock-report/list'
// production Store
const rawMatStockName = 'store-management/raw-material-stock/'
export const rawMatStockList = rawMatStockName + 'list'
export const rawMatStockStore = rawMatStockName + 'store'
export const rawMatStockUpdate = rawMatStockName + 'update'
export const rawMatStockToggleStatus = rawMatStockName + 'toggle-status'
export const rawMatAvailableStock = rawMatStockName + 'get-available-stock'

// production purchase
const rawMatPurchase = 'store-management/raw-material-purchase/'
export const rawMatPurchaseList = rawMatPurchase + 'list'
export const rawMatPurchaseStore = rawMatPurchase + 'store'
export const rawMatPurchaseUpdate = rawMatPurchase + 'update'
export const rawMatAvailableStockWithAmount = rawMatPurchase + 'get-available-stock-with-unit-price'

// production purchase
const rawMatPurchaseRec = 'store-management/raw-material-purchase-receive/'
export const rawMatPurchaseForRecList = rawMatPurchase + 'list-receive'
export const rawMatPurchaseRecList = rawMatPurchaseRec + 'list'
export const rawMatPurchaseRecStore = rawMatPurchaseRec + 'store'

export const productDashboard = 'store-management/product-dashboard/dashboard-data'

// raw-raterial-stock-report
export const rawStockReportList = 'store-management/raw-raterial-stock-report/list'
